import React from 'react'

export class Footer extends React.Component {
    render(){
        return(
            <footer className="footer" id="footer">Footer</footer>
        );
    }
}